import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { POLICY_META } from '../content/privacyPolicyStrings';
import './PrivacyPolicyPage.css';

export default function SupportPage() {
  const { contactEmail } = POLICY_META;

  useEffect(() => {
    document.documentElement.lang = 'en';
    document.title = 'Bolomde! - Support';
  }, []);

  return (
    <div className="pp-wrap">
      <header className="pp-hero">
        <div className="pp-hero-top">
          <div className="pp-hero-main">
            <div className="pp-kicker">
              <span className="pp-dot" aria-hidden="true" />
              Support
            </div>
            <h1 className="pp-title">Bolomde! Support</h1>
            <p className="pp-sub">
              Need help, have questions, or want to report an issue with the Bolomde! app?
            </p>
          </div>
          <Link className="pp-page-nav" to="/">
            Privacy Policy
          </Link>
        </div>
      </header>

      <main className="pp-main" role="main">
        <section className="pp-section">
          <h2 className="pp-h2">Contact us</h2>
          <p>
            Please reach out to us at:{' '}
            <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </p>
        </section>
      </main>
    </div>
  );
}
